<template>
<div class="chapter">
<div class="inner_page">
<div class="preface" id="fm1">
<p class="center2">Tor Books by James O’Neal</p>
<p class="center3"><em>The Human Disguise</em><br/><em>The Double Human</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429949323_epub_fm1_r1.vue?525659ee